const invoiceLabels = {
	draft: 'Aankomend',
	open: 'Te betalen',
	paid: 'Betaald',
	uncollectible: 'Mislukt',
	void: 'Verlopen'
};

const invoiceColors = {
	draft: 'light-blue',
	open: 'amber',
	paid: 'green',
	uncollectible: 'deep-orange',
	void: 'red'
};

enum InvoiceStatus {
	draft = 'draft',
	open = 'open',
	paid = 'paid',
	uncollectible = 'uncollectible',
	void = 'void'
}

export { InvoiceStatus, invoiceLabels, invoiceColors };
